export function Visibility({ visible, children }) {
  if(!visible) {
    return null;
  }

  return children;
}
